import { isAfter, isBefore, isSameDay, isWithinInterval, startOfDay } from '@repo/date-time';
const hasFlag = (date, flaggedDates, flag) => flaggedDates.some((dayFlag) => dayFlag.flag === flag && isSameDay(dayFlag.date, date));
const resolveHighlight = (date, selectionStart, selectionEnd) => {
    if (!selectionStart)
        return undefined;
    const end = selectionEnd ?? selectionStart;
    if (isSameDay(date, selectionStart) && isSameDay(date, end))
        return 'startAndFinish';
    if (isSameDay(date, selectionStart))
        return 'start';
    if (isSameDay(date, end))
        return 'finish';
    if (isWithinInterval(date, { start: selectionStart, end }))
        return 'during';
    return undefined;
};
export function mapDateToCalendarDay({ date, flaggedDates, today, minDate, maxDate, selectionStart, selectionEnd, }) {
    return {
        key: `${date.getFullYear()}_${date.getMonth() + 1}_${date.getDate()}`,
        date,
        alert: hasFlag(date, flaggedDates, 'alert'),
        warning: hasFlag(date, flaggedDates, 'warning'),
        isInThePast: isBefore(date, today),
        isBeforeMinDate: minDate !== undefined && isBefore(date, startOfDay(minDate)),
        isAfterMaxDate: isAfter(date, maxDate),
        highlight: resolveHighlight(date, selectionStart, selectionEnd),
    };
}
